<template>
  <!-- <p class="text-center">
      Support PIN:
      <span v-if="supportToken" class="font-bold">{{ supportToken }}</span>
      <gg-btn v-else
              small
              :loading="loadingSupportToken"
              @click.stop="requestToken">
        Request
      </gg-btn>
  </p> -->
  <gg-card>
    <gg-card-text class="text-center" style="font-size:1.2em;">
      <p>
        Customer ID:
        <span class="font-bold">{{ this.SessionProfile.accountId }}</span>
      </p>
      Support PIN:
      <span v-if="supportToken" class="font-bold">{{ supportToken }}</span>
      <gg-btn v-else
              small
              :loading="loadingSupportToken"
              @click.stop="requestToken">
        Request
      </gg-btn>
    </gg-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SupportToken',
  computed: mapGetters(['supportToken', 'loadingSupportToken', 'SessionProfile']),
  methods: {
    ...mapActions(['getSupportToken', 'reportError']),
    async requestToken () {
      try {
        await this.getSupportToken()
      } catch (e) {
        this.reportError(e)
      }
    }
  }
}
</script>
